import { render, staticRenderFns } from "./funcionarios.vue?vue&type=template&id=32c6d8a2&"
import script from "./funcionarios.vue?vue&type=script&lang=js&"
export * from "./funcionarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports